import { defineMessages, useIntl } from 'react-intl';

import type { InputType } from './types';

const startIconMessages = defineMessages({
  openDatePicker: {
    id: 'Input.openDatePicker',
    defaultMessage: 'Open date picker',
    description: 'Accessible name for the default date input calendar button',
  },
  openDateTimePicker: {
    id: 'Input.openDateTimePicker',
    defaultMessage: 'Open date and time picker',
    description:
      'Accessible name for the default datetime-local input calendar button',
  },
});

const endIconMessages = defineMessages({
  clearInput: {
    id: 'Input.clearInput',
    defaultMessage: 'Clear',
    description: 'Accessible name for the input clear button',
  },
});

export const useStartIcon = ({
  type,
  inputRef,
}: {
  type: InputType;
  inputRef: React.RefObject<HTMLInputElement>;
}) => {
  const intl = useIntl();

  switch (type) {
    case 'date':
      return {
        startIcon: 'calendar-today',
        startIconLabel: intl.formatMessage(startIconMessages.openDatePicker),
        startIconOnClick: () => inputRef.current?.showPicker(),
      };
    case 'datetime-local':
      return {
        startIcon: 'calendar-today',
        startIconLabel: intl.formatMessage(
          startIconMessages.openDateTimePicker,
        ),
        startIconOnClick: () => inputRef.current?.showPicker(),
      };
    case 'search':
      return { startIcon: 'search' };
    default:
      return {};
  }
};

export const useEndIcon = ({
  inputRef,
  onChange,
}: {
  inputRef: React.RefObject<HTMLInputElement>;
  onChange: (value: string | null) => void;
}) => {
  const intl = useIntl();
  return {
    endIcon: 'x',
    endIconLabel: intl.formatMessage(endIconMessages.clearInput),
    endIconOnClick: () => {
      onChange(null);
      inputRef.current?.focus();
    },
  };
};
